// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@flip/XDL/Icons/Close";
import { buttonTransparent } from "@flip/XDL/PreStyle/button";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import { getSystemColor } from "@flip/XDL/Utilities/color";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.regular,
            color: getSystemColor("common.ui1"),
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: 14px;
                word-break: break-word;
            `,
        },
        color: "common.ui4",
        // XNG-Changes: FLIP-968
        iconProps: {
            size: 8,
            src: Close,
            color: getSystemColor("common.ui1"),
        },
        // XNG-Changes: FLIP-968
        mergeCss: true,
        css: css`
            min-height: 22px;
            border-radius: 4px;
            flex-direction: row-reverse;
            align-items: center;
            gap: 4px;
            padding: 4px 8px;
            margin: 0 8px 8px 0;
            button {
                margin-right: 4px;
                ${buttonTransparent}
                display: flex;
            }
        `,
    },
} as xBaseTheme["tag"];
